import request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 提交工作室信息
   */
  static submitStudioMsg(params) {
    return request({
      url: 'store/create/check_member_info',
      host: config.HOST_STORE,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取工作室类型详情
   */
  static getStoreTypeInfoById(storeTypeId) {
    return request({
      url: `store_type`,
      host: config.HOST_STORE,
      params: {
        id: storeTypeId
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Register/StudioMsg/StudioMsgServ.js